import React from 'react'
import BranchesTable from './components/BranchesTable'


export default function Branches() {
  return (
    <BranchesTable />
  )
}